// src/pages/pengamatan/destrak/DestrakTableHeader.jsx
import React from 'react';
import { TableHead, TableRow, TableCell, Checkbox } from '@mui/material';
import './css/DestrakTableHeader.css';

const DestrakTableHeader = ({ selectedItems, orders, handleSelectAll }) => {
  const headerConfig = [
    { 
      id: 'checkbox', 
      label: '', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header fixed checkbox',
      component: (
        <Checkbox
          indeterminate={selectedItems.length > 0 && selectedItems.length < orders.length}
          checked={orders.length > 0 && selectedItems.length === orders.length}
          onChange={handleSelectAll}
        />
      )
    },
    { 
      id: 'status_pengamatan', 
      label: 'Status Pengamatan', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header fixed status-pengamatan'
    },
    { 
      id: 'tanggal_pengamatan', 
      label: 'Tanggal Pengamatan', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header fixed tanggal-pengamatan'
    },
    { 
      id: 'tanggal_forcing', 
      label: 'Tanggal Forcing', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'umur', 
      label: 'Umur', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'lokasi', 
      label: 'Lokasi', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header fixed lokasi'
    },
    { 
      id: 'plot', 
      label: 'Plot', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header fixed plot'
    },
    { 
      id: 'status', 
      label: 'Status', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'bibit_header', 
      label: 'BIBIT', 
      rowSpan: 1, 
      colSpan: 3,
      className: 'destrak-table-header'
    },
    { 
      id: 'awal_rawat', 
      label: 'Awal Rawat', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'no_sample', 
      label: 'No. Sample', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'size', 
      label: 'Size', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'berat_tanaman', 
      label: 'Berat Tanaman', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'berat_buah_crown', 
      label: 'Berat Buah & Crown', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'berat_buah', 
      label: 'Berat Buah', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
    { 
      id: 'berat_crown', 
      label: 'Berat Crown', 
      rowSpan: 2, 
      colSpan: 1,
      className: 'destrak-table-header'
    },
      {
    id: 'diameter_buah',
    label: 'Diameter Buah',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'panjang_buah',
    label: 'Panjang Buah',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'panjang_crown',
    label: 'Panjang Crown',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'panjang_pedangkel',
    label: 'Panjang Pedangkel',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'berat_pedangkel',
    label: 'Berat Pedangkel',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'panjang_d_leaf',
    label: 'Panjang D-Leaf',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'lebar_d_leaf',
    label: 'Lebar D-Leaf',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'berat_d_leaf',
    label: 'Berat D-Leaf',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'jumlah_d_leaf',
    label: 'Jumlah D-Leaf',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  },
  {
    id: 'jumlah_mata',
    label: 'Jumlah Mata',
    rowSpan: 1, 
    colSpan: 3,
    className: 'destrak-table-header'
  },
  {
    id: 'size_buah',
    label: 'Size Buah',
    rowSpan: 2,
    colSpan: 1,
    className: 'destrak-table-header'
  }
  ];

  const subHeaderConfig = [
    { 
      id: 'varietas', 
      label: 'Varietas', 
      className: 'destrak-sub-header'
    },
    { 
      id: 'kelas', 
      label: 'Kelas', 
      className: 'destrak-sub-header'
    },
    { 
      id: 'jenis', 
      label: 'Jenis', 
      className: 'destrak-sub-header'
    },
    { 
      id: 'kanan', 
      label: 'Kanan', 
      className: 'destrak-sub-header'
    },
    { 
      id: 'kiri', 
      label: 'Kiri', 
      className: 'destrak-sub-header'
    },
    { 
      id: 'atas', 
      label: 'Atas', 
      className: 'destrak-sub-header'
    }
  ];

  return (
    <TableHead>
      {/* Baris Header Pertama */}
      <TableRow>
        {headerConfig.map((header) => (
          <TableCell
            key={header.id}
            rowSpan={header.rowSpan}
            colSpan={header.colSpan}
            className={header.className}
            padding={header.id === 'checkbox' ? 'checkbox' : 'normal'}
          >
            {header.component || header.label}
          </TableCell>
        ))}
      </TableRow>
      
      {/* Baris Header Kedua (Sub-header untuk BIBIT) */}
      <TableRow>
        {subHeaderConfig.map((subHeader) => (
          <TableCell
            key={subHeader.id}
            className={subHeader.className}
          >
            {subHeader.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default DestrakTableHeader;